import { render } from "./StudentPlaceExercise.vue?vue&type=template&id=ae15e096"
import script from "./StudentPlaceExercise.vue?vue&type=script&lang=js"
export * from "./StudentPlaceExercise.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__